<div class="anc-dr" [class.anc-dr--single]="mode === 'single'">
    <aside class="anc-dr-presets" *ngIf="showPresets">
        <button type="button" class="anc-dr-preset"
                *ngFor="let p of presets"
                [class.anc-dr-preset--on]="activePreset === p.id"
                (click)="applyPreset(p)">{{ p.label | translate }}</button>
    </aside>

    <div class="anc-dr-cal">
        <!-- Header: ‹  Month YYYY ⌄  › -->
        <div class="anc-dr-nav">
            <button type="button" class="anc-dr-navbtn" data-testid="dr-prev" (click)="prev()" [attr.aria-label]="'Previous' | translate">
                <span class="icon icon-chevron-left" aria-hidden="true"></span>
            </button>

            <button type="button" class="anc-dr-title" data-testid="dr-title" (click)="stepView()">
                <span *ngIf="view === 'days'">{{ monthLabel }}</span>
                <span *ngIf="view === 'months'">{{ anchorYear }}</span>
                <span *ngIf="view === 'years'">{{ yearGrid[0] }} – {{ yearGrid[yearGrid.length - 1] }}</span>
                <span class="anc-dr-caret icon icon-chevron-down" aria-hidden="true"></span>
            </button>

            <button type="button" class="anc-dr-navbtn" data-testid="dr-next" (click)="next()" [attr.aria-label]="'Next' | translate">
                <span class="icon icon-chevron-right" aria-hidden="true"></span>
            </button>
        </div>

        <!-- Days view -->
        <ng-container *ngIf="view === 'days'">
            <div class="anc-dr-weekdays">
                <span *ngFor="let w of weekdays" class="anc-dr-weekday">{{ w | translate }}</span>
            </div>
            <div class="anc-dr-divider"></div>
            <div class="anc-dr-grid">
                <button type="button"
                        *ngFor="let cell of grid"
                        class="anc-dr-day"
                        [class.anc-dr-day--out]="!cell.inMonth"
                        [class.anc-dr-day--start]="isStart(cell.date)"
                        [class.anc-dr-day--end]="isEnd(cell.date)"
                        [class.anc-dr-day--in]="inRange(cell.date)"
                        [disabled]="isDisabled(cell.date)"
                        [attr.data-date]="cell.date"
                        (mouseenter)="onHover(cell.date)"
                        (click)="selectDay(cell.date)">
                    <span class="anc-dr-day-num">{{ cell.day }}</span>
                </button>
            </div>
        </ng-container>

        <!-- Months quick view -->
        <div class="anc-dr-monthgrid" *ngIf="view === 'months'">
            <button type="button"
                    *ngFor="let m of months; let i = index"
                    class="anc-dr-chip"
                    [class.anc-dr-chip--on]="isCurrentMonth(i)"
                    (click)="selectMonth(i)">{{ m | translate }}</button>
        </div>

        <!-- Years quick view -->
        <div class="anc-dr-yeargrid" *ngIf="view === 'years'">
            <button type="button"
                    *ngFor="let y of yearGrid"
                    class="anc-dr-chip"
                    [class.anc-dr-chip--on]="y === anchorYear"
                    (click)="selectYear(y)">{{ y }}</button>
        </div>

        <div class="anc-dr-foot">
            <button
                type="button"
                libAncButton
                variant="tertiary"
                size="small"
                class="anc-dr-clear"
                data-testid="dr-clear"
                (click)="clear()"
            >
                <span translate>Clear</span>
            </button>
            <button
                type="button"
                libAncButton
                variant="primary"
                size="small"
                class="anc-dr-apply"
                data-testid="dr-apply"
                [disabled]="!canApply"
                (click)="apply()"
            >
                <span translate>Apply</span>
            </button>
        </div>
    </div>
</div>
